import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMarketForLead as GetMarketForLeadQuery,
    GetMarketForLeadVariables as GetMarketForLeadVariables,
    GetMarketForLead_lead_market as Market,
} from 'nutshell-graphql-types';

import GET_MARKET_FOR_LEAD from '../queries/get-market-for-lead.graphql';

export const useGetMarketForLead = (
    leadId: string
): {
    market: Market | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetMarketForLeadQuery,
        GetMarketForLeadVariables
    >(GET_MARKET_FOR_LEAD, {
        variables: {
            leadId,
        },
    });

    return {
        market: data && data.lead && data.lead.market,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
